// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import Vuex from 'vuex';

import App from './App'
import router from './router';
import Api from './plugins/Api.js';

import VueClip from 'vue-clip';
import Access from './plugins/Access.js';
import VTooltip from 'v-tooltip';

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueClip);
Vue.use(Access);
Vue.use(VTooltip);
Vue.use(Api);

Vue.http.interceptors.push((request, next)  => {
  // continue to next interceptor

  request.headers['Content-Type'] = 'multipart/form-data';

  if(store.getters.getToken){
    request.body.token = store.getters.getToken;
  }

  next(function (response) {

    try{

      if(response.body){
        response.body = JSON.parse(response.body);
      }

    } catch(err){
      // console.log(err);
    }

    if(!response.body.status){

      if(response.body.code && response.body.code == 401){
        store.commit('setStatus', {
          status: false,
          message: response.body.message
        });

        store.dispatch('logout').then(function () {
          router.replace('/login');
        });
      }

    }



  }.bind(this));
});


import status from './store/modules/status.js';
import authentication from './store/modules/authentication.js';

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    status,
    authentication
  }
});

router.beforeEach((to, from, next) => {

	store.commit('activeRoute', to);
	store.commit('updateAuth');

  if (to.matched.some(record => record.meta.requiresAuth)) {

    if(!store.getters.checkAuth){
      store.commit('setStatus', {
        status: false,
        message: "You are not logged in. Please log in to continue"
      });
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {

      store.dispatch('setRoles').then(function(){
        
        if(store.getters.hasPermission){
          next();
        } else {
          store.commit('setStatus', {
            status: false,
            message: "You do not have permissions to access that area."
          });

          next({
            path: '/users'
          });

        }

      })
    }
  } else {

    if(store.getters.checkAuth) {
      store.dispatch('setRoles').then(function () {
        if (to.name == 'Login') {
          next({
            path: '/account-details'
          });
        } else {
          next();
        }
      })
    } else {
      next();
    }


  }

});





/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js